import { Link, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import {
	AppBar,
	Box,
	Typography,
	Toolbar,
	Button,
	/* SS-2815
	InputBase,
	Popper,
	Paper,
	ClickAwayListener,*/
} from '@mui/material';
import { useUserContext } from 'contexts/UserContext';

/* SS-2815 
import fakeData from 'features/IRWorkstation/constants/fakeData';
import SearchIcon from '@mui/icons-material/Search';
import StatusPill from 'features/IRWorkstation/components/StatusPill';
*/

const visitablePages = [
	{ key: 'overview', label: 'My Day', path: '' },
	{ key: 'entity_dashboard', label: 'Entity Dashboard', path: 'entities' },
	{ key: 'alert_center', label: 'Alert Center', path: 'alert_center' },
	{
		key: 'settings',
		label: 'Settings',
		path: 'settings',
		tenantAdminOnly: true,
	},
	// {
	// 	key: 'co_invest_dashboard',
	// 	label: 'Co-Invest Dashboard',
	// 	path: 'co-invests',
	// },
	// { key: 'reporting', label: 'Reporting', path: 'reporting' },
	// { key: 'analytics', label: 'Analytics', path: 'analytics' },
];

const Navbar = () => {
	const { pathname } = useLocation();
	const { user } = useUserContext();

	const visiblePages = visitablePages.filter((page) => {
		if (page.tenantAdminOnly && user?.role !== 'tenant_admin') {
			return false;
		}

		return true;
	});

	/* SS-2815 
	const [lpOpen, setLpOpen] = useState(false);
	const [lpSearch, setLpSearch] = useState('');
    const lpAnchor = useRef(null);

	const filtered = fakeData.lpOptions.filter((lp) =>
		lp.name.toLowerCase().includes(lpSearch.toLowerCase())
	); 

	const handleSelectLP = (lp) => {
		setLpOpen(false);
		setLpSearch('');
		onOpenLP(lp);
	};

	*/

	return (
		<AppBar position='static'>
			<Toolbar>
				<Typography
					sx={{
						fontSize: '13px',
						fontWeight: 600,
						color: 'text.primary',
						mr: 3,
						whiteSpace: 'nowrap',
					}}
				>
					Investor Engagement Manager
				</Typography>

				<Box
					sx={{
						width: '1px',
						height: 16,
						backgroundColor: 'border.light',
						mx: '10px',
						flexShrink: 0,
					}}
				/>

				<Box sx={{ display: 'flex', gap: 2 }}>
					{visiblePages.map((page) => {
						const pathSegment = pathname.split('/workstation/')[1] || '';
						const isActive = pathSegment === page.path;

						return (
							<Button
								key={page.key}
								component={Link}
								to={page.path}
								relative='route'
								sx={{
									my: 1,
									color: isActive ? 'text.primary' : 'text.secondary',
									fontWeight: isActive ? 700 : 600,
									textTransform: 'none',
									fontSize: '12px',
									'&:hover': {
										backgroundColor: 'background.subtle',
									},
									backgroundColor: isActive
										? 'background.subtle'
										: 'transparent',
									pointerEvents: isActive ? 'none' : 'auto',
								}}
							>
								{page.label}
							</Button>
						);
					})}
				</Box>

				<Box flex={1} />

				{/* SS-2815 hiding click away search to implement later 
				<ClickAwayListener onClickAway={() => setLpOpen(false)}>
					<Box position='relative'>
						<Box
							ref={lpAnchor}
							onClick={() => setLpOpen((o) => !o)}
							display='flex'
							alignItems='center'
							justifyContent='center'
							sx={{
								width: 29,
								height: 29,
								borderRadius: '6px',
								border: '1px solid',
								borderColor: 'border.main',
								cursor: 'pointer',
								backgroundColor: 'background.subtle',
								'&:hover': { backgroundColor: 'background.subtle' },
							}}
						>
							<SearchIcon fontSize='small' sx={{ color: 'text.primary' }} />
						</Box>
						<Popper
							open={lpOpen}
							anchorEl={lpAnchor.current}
							placement='bottom-end'
							sx={{ zIndex: 1300, mt: '4px' }}
						>
							<Paper
								display='flex'
								flexDirection='column'
								sx={{
									width: 290,
									maxHeight: 360,
									overflow: 'hidden',
									border: '0.5px solid',
									borderColor: 'border.main',
									borderRadius: '8px',
								}}
							>
								<Box
									sx={{
										padding: '8px',
										borderBottom: '0.5px solid',
										borderColor: 'border.light',
										backgroundColor: 'background.subtle',
									}}
								>
									<InputBase
										autoFocus
										placeholder='Search LPs…'
										value={lpSearch}
										onChange={(e) => setLpSearch(e.target.value)}
										sx={{ fontSize: '12px', width: '100%', px: 1 }}
									/>
								</Box>
								<Box flex={1} sx={{ overflowY: 'auto' }}>
									{filtered.map((lp) => (
										<Box
											key={lp.name}
											onClick={() => handleSelectLP(lp)}
											display='flex'
											alignItems='center'
											sx={{
												gap: 1,
												padding: '7px 10px',
												cursor: 'pointer',
												'&:hover': { backgroundColor: 'background.subtle' },
												borderBottom: '0.5px solid',
												borderColor: 'border.light',
											}}
										>
											<Box flex={1} sx={{ minWidth: 0 }}>
												<Typography variant='caption' sx={{ fontWeight: 500 }}>
													{lp.name}
												</Typography>
												<Typography
													sx={{ fontSize: '10px', color: 'text.tertiary' }}
												>
													{lp.type} · {lp.tier}
												</Typography>
											</Box>
											<StatusPill
												label={lp.health === 'At Risk' ? 'At Risk' : lp.reup}
												color={
													lp.reup === 'High'
														? 'green'
														: lp.health === 'At Risk'
															? 'red'
															: lp.reup === 'Medium'
																? 'amber'
																: 'gray'
												}
											/>
										</Box>
									))}
									{filtered.length === 0 && (
										<Typography
											variant='caption'
											align='center'
											sx={{
												padding: 2,
												color: 'text.tertiary',
											}}
										>
											No LPs found
										</Typography>
									)}
								</Box>
							</Paper>
						</Popper>
					</Box>
				</ClickAwayListener>
				*/}
			</Toolbar>
		</AppBar>
	);
};

Navbar.propTypes = {
	onOpenLP: PropTypes.func.isRequired,
};

export default Navbar;
